import { LoginRedirect, LogoutRedirect } from 'eclipx.ui';
import store from '../store/index';
import DragonBallLayout from '../layouts/DragonballLayout';
import Quotes from '../pages/Quotes/Quotes';
import Quote from '../pages/Quote/Quote';
import LeaseDetails from '../pages/Quote/LeaseDetails/LeaseDetails';
import ColourAndExtras from '../pages/Quote/ColourAndExtras/ColourAndExtras';
import OrderDetails from '../pages/Quote/OrderDetails/OrderDetails';
import Review from '../pages/Quote/Review/Review';
import Car from '../pages/Quote/Car/Car';
import CarDetails from '../pages/Quote/Car/CarDetails';
import CarVariants from '../pages/Quote/Car/CarVariants';
import QuoteGuard from './QuoteGuard';

export const NewQuoteRouteParam = 'new-quote';
import { onLogout } from '../vue-apollo';

export default [
  // Un Authenticated Routes
  {
    path: '/login',
    component: LoginRedirect,
    meta: { skipAuthentication: true },
    props: {
      redirectUri: '/'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { skipAuthentication: true },
    component: LogoutRedirect,
    beforeEnter: (to, from, next) => {
      // Clear the  local user when logging out
      store.commit('auth/clearUser');
      next((vm) => {
        onLogout(vm.$apollo);
      });
    }
  },
  { path: '/', redirect: '/quotes' },
  {
    path: '/quotes',
    name: 'quotes',
    meta: { layout: DragonBallLayout },
    component: Quotes
  },
  {
    name: 'quote',
    path: '/quotes/:quoteId',
    redirect: '/quotes/:quoteId/car',
    props: true,
    component: Quote,
    beforeEnter: QuoteGuard,
    children: [
      {
        name: 'quoteCar',
        path: 'car',
        redirect: '/quotes/:quoteId/car/details',
        meta: { layout: DragonBallLayout },
        props: true,
        component: Car,
        beforeEnter: QuoteGuard,
        children: [
          {
            name: 'quoteCarDetails',
            path: 'details',
            meta: { layout: DragonBallLayout },
            component: CarDetails,
            beforeEnter: QuoteGuard
          },
          {
            name: 'quoteCarVariants',
            path: 'variants',
            meta: { layout: DragonBallLayout },
            component: CarVariants,
            beforeEnter: QuoteGuard
          }
        ]
      },
      {
        name: 'quoteLeaseDetails',
        path: 'lease-details',
        meta: { layout: DragonBallLayout },
        component: LeaseDetails,
        beforeEnter: QuoteGuard
      },
      {
        name: 'quoteColourAndExtras',
        path: 'colour-and-extras',
        meta: { layout: DragonBallLayout },
        component: ColourAndExtras,
        beforeEnter: QuoteGuard
      },
      {
        name: 'quoteOrderDetails',
        path: 'order-details',
        meta: { layout: DragonBallLayout },
        component: OrderDetails,
        beforeEnter: QuoteGuard
      },
      {
        name: 'quoteReview',
        path: 'review-quote',
        meta: { layout: DragonBallLayout },
        component: Review,
        beforeEnter: QuoteGuard
      }
    ]
  }
];
